angular.module('ihestiaRestServicesBase')
  .factory('ihestiaRestVehicleDictionaryBodyTypesSvc', ['ihestiaRestAbstractVehicleDictionariesSvc',
    function(ihestiaRestAbstractVehicleDictionariesSvc) {

      var RestDictionaryVehicleSvc = function() {
        ihestiaRestAbstractVehicleDictionariesSvc.apply(this, arguments);

        this.id = 'bodyTypes';

      };
      return new RestDictionaryVehicleSvc();
    }
  ]);